import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { VideoPlayer, Viewer, Controls, PlayButton, FullscreenButton, ProgressControl, DurationControl } from '../../src/index';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "examples"
    }}>{`Examples`}</h1>
    <h2 {...{
      "id": "using-native-controls"
    }}>{`Using native controls`}</h2>
    <Playground __position={0} __code={'<VideoPlayer>\n  <Viewer\n    url=\"http://dl5.webmfiles.org/big-buck-bunny_trailer.webm\"\n    nativeControls\n  />\n</VideoPlayer>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      VideoPlayer,
      Viewer,
      Controls,
      PlayButton,
      FullscreenButton,
      ProgressControl,
      DurationControl,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <VideoPlayer mdxType="VideoPlayer">
    <Viewer url="http://dl5.webmfiles.org/big-buck-bunny_trailer.webm" nativeControls mdxType="Viewer" />
  </VideoPlayer>
    </Playground>
    <h2 {...{
      "id": "custom-poster"
    }}>{`Custom poster`}</h2>
    <Playground __position={1} __code={'<VideoPlayer>\n  <Viewer\n    url=\"http://dl5.webmfiles.org/big-buck-bunny_trailer.webm\"\n    poster=\"http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/images/BigBuckBunny.jpg\"\n    nativeControls\n  />\n</VideoPlayer>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      VideoPlayer,
      Viewer,
      Controls,
      PlayButton,
      FullscreenButton,
      ProgressControl,
      DurationControl,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <VideoPlayer mdxType="VideoPlayer">
    <Viewer url="http://dl5.webmfiles.org/big-buck-bunny_trailer.webm" poster="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/images/BigBuckBunny.jpg" nativeControls mdxType="Viewer" />
  </VideoPlayer>
    </Playground>
    <h2 {...{
      "id": "using-multiples-sources"
    }}>{`Using multiples sources`}</h2>
    <Playground __position={2} __code={'<VideoPlayer>\n  <Viewer nativeControls>\n    <Viewer.Source\n      src=\"http://dl5.webmfiles.org/big-buck-bunny_trailer.webm\"\n      type=\"video/webm\"\n    />\n    <Viewer.Source\n      src=\"http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4\"\n      type=\"video/mp4\"\n    />\n  </Viewer>\n</VideoPlayer>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      VideoPlayer,
      Viewer,
      Controls,
      PlayButton,
      FullscreenButton,
      ProgressControl,
      DurationControl,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <VideoPlayer mdxType="VideoPlayer">
    <Viewer nativeControls mdxType="Viewer">
      <Viewer.Source src="http://dl5.webmfiles.org/big-buck-bunny_trailer.webm" type="video/webm" />
      <Viewer.Source src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" type="video/mp4" />
    </Viewer>
  </VideoPlayer>
    </Playground>
    <h2 {...{
      "id": "add-vtt-files"
    }}>{`Add VTT files`}</h2>
    <Playground __position={3} __code={'<VideoPlayer>\n  <Viewer nativeControls>\n    <Viewer.Source\n      src=\"https://d2zihajmogu5jn.cloudfront.net/elephantsdream/ed_hd.mp4\"\n      type=\"video/mp4\"\n    />\n    <Viewer.Track\n      kind=\"captions\"\n      srclang=\"en\"\n      label=\"English\"\n      src=\"/public/vtt/elephantsdream/captions.en.vtt\"\n      default\n    />\n    <Viewer.Track\n      kind=\"captions\"\n      srclang=\"ja\"\n      label=\"Japanese\"\n      src=\"/public/vtt/elephantsdream/captions.ja.vtt\"\n    />\n  </Viewer>\n</VideoPlayer>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      VideoPlayer,
      Viewer,
      Controls,
      PlayButton,
      FullscreenButton,
      ProgressControl,
      DurationControl,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <VideoPlayer mdxType="VideoPlayer">
    <Viewer nativeControls mdxType="Viewer">
      <Viewer.Source src="https://d2zihajmogu5jn.cloudfront.net/elephantsdream/ed_hd.mp4" type="video/mp4" />
      <Viewer.Track kind="captions" srcLang="en" label="English" src="/public/vtt/elephantsdream/captions.en.vtt" default />
      <Viewer.Track kind="captions" srcLang="ja" label="Japanese" src="/public/vtt/elephantsdream/captions.ja.vtt" />
    </Viewer>
  </VideoPlayer>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      